import { Component, OnInit, ViewChild } from '@angular/core';
import { RepositoryService } from '../../../smoothr-web-app-core/services/repository/repository.service';
import ArticleCategory from '../../../smoothr-web-app-core/models/ArticleCategory';
import { ActivatedRoute, Router } from '@angular/router';
import { ToOrderButtonComponent } from '../../components/to-order-button/to-order-button.component';
import { IonSearchbar, ModalController, PopoverController } from '@ionic/angular';
import { ModalInfoComponent } from '../../components/modal-info/modal-info.component';
import Article from '../../../smoothr-web-app-core/models/Article';
import ArticleGroup from '../../../smoothr-web-app-core/models/ArticleGroup';
import { AppComponent } from '../../app.component';
import { PreorderType } from '../../../smoothr-web-app-core/enums/PreorderType';
import * as moment from 'moment';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { OrderUtils } from '../../../smoothr-web-app-core/utils/order-utils';
import { OrderType } from '../../../smoothr-web-app-core/enums/OrderType';
import RepositoryDirective from '../../../smoothr-web-app-core/directives/repository-directive';
import { environment } from '../../../environments/environment';
import {
	axiosErrorToMessage,
	defaultsToArticleOption,
	getCustomAvailability,
	isAvailableByHours,
	numberToCurrency,
	sleep,
} from '../../../smoothr-web-app-core/utils/utils';
import { AnalyticsService } from '../../../smoothr-web-app-core/services/analytics/analytics.service';
import { NavigationService, NAVIGATIONURLS } from 'src/app/services/navigation.service';
import { BehaviorSubject, debounceTime } from 'rxjs';
import { TOGGLE_TAG } from 'src/app/components/menu-filters/menu-filters.component';
import { OrderContentModalComponent } from 'src/app/components/order-content-modal/order-content-modal.component';
import { ChangeVenuePopoverComponent, LeaveVenue } from 'src/app/components/change-venue-popover/change-venue-popover.component';
import { FormControl } from '@angular/forms';
import { RecomendationArticleModalComponent } from 'src/app/components/recomendation-article-modal/recomendation-article-modal.component';
import PromoCode from 'src/smoothr-web-app-core/models/PromoCode';
import { SelectionProductFromFreeArticleComponent } from 'src/app/components/selection-product-from-free-article/selection-product-from-free-article.component';
import Order from 'src/smoothr-web-app-core/models/Order';
import { PromoCodeType } from 'src/smoothr-web-app-core/models/PromoCodeType';
import { ChooseSizeOfProductComponent } from 'src/app/components/choose-size-of-product/choose-size-of-product.component';
import { ValidationUtils } from 'src/smoothr-web-app-core/utils/validation-utils';
import { SelectLanguageModalComponent } from 'src/app/components/select-language-modal/select-language-modal.component';
import { AskToCreateAccountModalComponent } from 'src/app/components/ask-to-create-account-modal/ask-to-create-account-modal.component';
import { FiltersModalComponent } from 'src/app/components/filters-modal/filters-modal.component';
import { ArticleCategoryType } from 'src/smoothr-web-app-core/enums/ArticleCategoryType';

@Component({
	selector: 'app-menu',
	templateUrl: './menu.page.html',
	styleUrls: ['menu.page.scss'],
})
export class MenuPage extends RepositoryDirective implements OnInit {
	static url = 'menu';

	@ViewChild(ToOrderButtonComponent, { static: false }) toOrderButton;
	@ViewChild('articleContent', { static: false }) articleList;
	@ViewChild(IonSearchbar, { static: false }) searchBar;
	@ViewChild('categoryList', { static: false }) categoryList;
	@ViewChild('inputDataSlider', { static: false }) slider;
	time = moment();
	environment = environment;
	scrollEvents = true;
	loading = false;
	searchTerm = '';
	categories: ArticleCategory[] = [];
	moment = moment;
	PreorderType = PreorderType;
	searchBarOpen = false;
	compoundFilers: string[] = [];
	selectedToggleTag = TOGGLE_TAG.All;
	public isOpenBasket$ = new BehaviorSubject<boolean>(false);
	public showFilters = false;
	public categoryItemOffset = '';
	public isLargeScreen = AppComponent.largeScreen;
	public isOpenPopoverBack = false;
	public categoryItemOffsetLast = '';
	public selectedFiltersArray: string[] = [];
	public openCheckout$ = new BehaviorSubject(false);
	showMessageNotification = false;
	public selectedDrinkSubCategory: string | null = null;
	public drinkSubCategories: any[] = [];
	get preorderType(): PreorderType {
		return this.order?.preorder?.type;
	}
	public messageNotification = '';
	public searchForm = new FormControl('');
	slideOptions = {
		spaceBetween: 0,
		initialSlide: 0,
		speed: 400,
		allowTouchMove: false,
	};
	public previousValue = 0;
	public hideCategory: boolean = false;
	notificationTimeout: any; // Declare a variable to store the timeout ID

	veganFilter = false;
	orderTotalPrice = OrderUtils.orderTotalPrice;
	numberToCurrency = numberToCurrency;

	constructor(
		public translate: TranslateService,
		protected repository: RepositoryService,
		private modalCtrl: ModalController,
		private snackbarCtrl: MatSnackBar,
		private analytics: AnalyticsService,
		private navigationService: NavigationService,
		private popover: PopoverController,
		private router: Router,
		private route: ActivatedRoute
	) {
		super(repository);
	}
	public selectedCategoryIndex$ = new BehaviorSubject<number>(0);
	private _selectedCategoryIndex = 0;

	get selectedCategoryIndex(): number {
		return this._selectedCategoryIndex;
	}

	set selectedCategoryIndex(value) {
		if (this._selectedCategoryIndex === value) {
			return;
		}
		this._selectedCategoryIndex = value;
		this.scrollTo(value);
	}

	get selectedCategory(): ArticleCategory {
		return this.categories[this.selectedCategoryIndex];
	}

	get isDrinkCategory(): boolean {
		return this.selectedCategory?.mainCategory === ArticleCategoryType.BEVERAGE;
	}

	get active(): boolean {
		return (
			this.order &&
			OrderUtils.articleGroupsTotalPrice(
				this.order.orderedArticles,
				this.order.type,
				this.order.preorder.type,
				this.order.terminalorder ? this.order.terminalorder.type : null
			) > 0
		);
	}

	get index(): number {
		return this.categories.findIndex(category => category._id === this.selectedCategory._id);
	}

	static async navigate(router: Router) {
		await router.navigateByUrl(MenuPage.url);
	}

	async ngOnInit() {
		await super.ngOnInit();
		switch (window.location.pathname) {
			case '/' + NAVIGATIONURLS.order():
				break;
			case '/' + NAVIGATIONURLS.paymentCancel():
				console.log(this.translate.instant('order.payment_cancel'));
				this.snackbarCtrl.open(this.translate.instant('order.payment_cancel'), null, {
					duration: 2000,
				});
				break;
			case '/' + NAVIGATIONURLS.paymentFail():
				console.log(this.translate.instant('order.payment_fail'));
				this.snackbarCtrl.open(this.translate.instant('order.payment_fail'), null, {
					duration: 5000,
				});
				break;
		}

		this.loading = true;
		this.repository.venue.emit(
			await this.repository.getVenue(this.order && this.order.venue ? this.order.venue : environment.customerGroup + '_master')
		);
		this.reloadCategories();
		this.loading = false;
		this.isOpenBasket$.subscribe(v => {});
		this.searchForm.valueChanges.pipe(debounceTime(600)).subscribe(v => {
			this.onSearchTermChanged(v);
		});
		this.route.queryParams.subscribe(params => {
			if (params && params.itemId) {
				const article = ([].concat(...this.venue.articleCategories.map(it => it.articles)) as Article[]).find(it => {
					return it.number === params.itemId;
				});
				if (article) {
					this.openModal(article, null, false, false, true);
				}
			}
			if (params && params.articleId && this.repository.addLoyaltyProduct$.getValue()) {
				const article = ([].concat(...this.venue.articleCategories.map(it => it.articles)) as Article[]).find(it => {
					return it._id === params.articleId;
				});
				if (article) {
					this.openModal(article, null, false, false, true);
				}
			}
			if (params && params.categoryId) {
				const categoryIndex = this.categories.findIndex(it => it._id === params.categoryId);
				if (categoryIndex) {
					this.scrollTo(categoryIndex);
				}
			}
		});
	}

	largeScreen(): boolean {
		return AppComponent.largeScreen;
	}
	ionViewDidEnter() {
		this.checkIfPromoCodeExist(this.order);
	}
	async showDialogToSelectProduct(articles: Article[], promocode: PromoCode, order: Order) {
		const foundActive = articles.find(it => it.visible && it.isActive);
		if (!foundActive) {
			this.repository.promoCodeFree$.next(null);

			return;
		}
		const result = await SelectionProductFromFreeArticleComponent.show(this.modalCtrl, articles, order);
		try {
			if (result?.data && result?.data[0]?.article) {
				const articleValue = result?.data[0]?.article;

				let articleGroup = new ArticleGroup();

				if (articleValue.groups.length > 0) {
					const resultOfMoval = await this.customModalGroup(articleValue, null, false, true);
					articleGroup = resultOfMoval;
				} else {
					articleGroup.article = articleValue;
					articleGroup.groups.push(
						...defaultsToArticleOption(articleValue, [], articleValue.defaults, this.order?.type, this.order.preorder.type)
					);
					articleGroup.quantity = 1;
					articleGroup.categoryName = null;
					articleGroup.isPromo = true;
				}
				if (articleGroup && articleGroup?.isPromo && articleGroup?.article?._id) {
					this.repository.onOrderChange(
						OrderUtils.applyPromo(this.translate, this.repository._venue, this.order, promocode, this.analytics, articleGroup)
					);
				}
			}
			this.repository.promoCodeFree$.next(null);
		} catch (e) {
			console.log('e', e);

			this.repository.promoCodeFree$.next(null);
		}
	}
	async checkIfPromoCodeExist(order: Order) {
		setTimeout(() => {
			console.log(order, this.repository._venue.articleCategories);
			if (order && order?.promoCode) {
				if (order.promoCode.type == PromoCodeType.COUPON) {
					const addedPromo = order.orderedArticles.find(it => order.promoCode.value.includes(it.article._id));

					if (!addedPromo) {
						let allArticles = [];
						this.repository._venue.articleCategories.forEach(cat => allArticles.push(...cat.articles));

						const freeArticle = allArticles.find(
							art => order.promoCode?.value?.indexOf(art?.masterId) >= 0 || order?.promoCode?.value?.indexOf(art._id) >= 0
						);

						if (!freeArticle) return;
						this.openModal(freeArticle, null, false, true);
					}
				}
			}
			const promoCode = this.repository.promoCodeFree$.getValue();

			if (promoCode && promoCode.type === PromoCodeType.FREE_ARTICLE) {
				let allArticles: Article[] = [];
				let productsRelatedToVenue: Article[] = [];
				this.repository._venue.articleCategories.forEach(cat => {
					allArticles.push(...cat.articles);
				});

				allArticles.forEach(art => {
					if (promoCode.value.includes(art._id) || promoCode.value.includes(art.masterId)) {
						productsRelatedToVenue.push(art);
					}
				});

				this.showDialogToSelectProduct(productsRelatedToVenue, promoCode, order);
				return;
			}
		}, 1500);
	}
	async scrollTo(index: number) {
		if (this.categories.length - 1 < index || index < 0) {
			return;
		}
		this.scrollEvents = false;
		if (this.selectedCategoryIndex !== index) {
			this.selectedCategoryIndex = index;

			await this.scrollCategoryListTo(index);
			await sleep(100);
			await this.scrollArticleListTo(index);
		}
		this.scrollEvents = true;
	}
	async customModalGroup(
		item: Article,
		category: ArticleCategory,
		addRecomendations: boolean = false,
		isPromo: boolean = false
	): Promise<ArticleGroup | null> {
		const articleGroup = new ArticleGroup();
		articleGroup.article = item;
		articleGroup.groups.push(...defaultsToArticleOption(item, [], item.defaults, this.order?.type, this.order.preorder.type));
		articleGroup.quantity = 1;
		articleGroup.categoryName = category?.name;
		if (isPromo) {
			articleGroup.isPromo = isPromo;
		}
		articleGroup.isPromo = isPromo;
		articleGroup.freeArticle = true;

		const modal = await this.modalCtrl.create({
			cssClass: AppComponent.largeScreen ? 'item-modal large-modal' : 'item-modal',
			component: ModalInfoComponent,
			componentProps: {
				articleGroup,
				noQuantity: true,
			},
			mode: 'ios',
			backdropDismiss: true,
		});
		await modal.present();
		const response = await modal.onDidDismiss();

		if (response.data && response.data.articleGroup) {
			return response.data.articleGroup;
		}
		return null;
	}

	async onScroll(event) {
		const newValue = event?.detail?.currentY;
		if (newValue > this.previousValue) {
			this.hideCategory = true;
		} else {
			this.hideCategory = false;
		}
		this.previousValue = event?.detail?.currentY;
		const categoryElements = [...this.articleList.el.children];
		const categoryIndex = categoryElements
			.map(el => el.offsetTop)
			.map((value, index, array) => {
				return (
					value <= event.detail.currentY &&
					((index < array.length - 1 && event.detail.currentY < array[index + 1]) || index === array.length - 1)
				);
			})
			.findIndex(value => value);
		let prevIndex = -1;

		if (this.selectedCategory) {
			prevIndex = this.categories.findIndex(category => category._id === this.selectedCategory._id);
		}
		if (prevIndex === categoryIndex) {
			return;
		}
		if (this.scrollEvents) {
			this.selectedCategoryIndex = categoryIndex;
			this.selectedCategoryIndex$.next(categoryIndex);
			await this.scrollCategoryListTo(categoryIndex);
		}
	}

	private async scrollCategoryListTo(index: number) {
		if (
			index < 0 ||
			!this.categoryList?.nativeElement?.children[index] ||
			(!this.categoryList?.nativeElement?.scrollTo && !this.categoryList?.nativeElement?.scrollLeft)
		) {
			return;
		}
		this.categoryList.nativeElement.scrollTo(this.categoryList.nativeElement.children[index].offsetLeft - 5, 0);
		await sleep(100);
	}
	checkPageIfHaveGrid(articleGroup: ArticleGroup) {
		console.log(articleGroup.article.groups.filter(it => !!it.tags.find(tag => tag.identifier === 'half_pizza')));
		return (
			articleGroup.article.groups.length > 0 &&
			articleGroup.article.groups.filter(it => !!it.tags.find(tag => tag.identifier === 'half_pizza')).length > 0
		);
		// return articleGroup.article.tags.find(it => it.identifier == 'half_pizza');
	}
	async addToBasket(
		item: Article,
		category: ArticleCategory,
		addRecomendations: boolean = false,
		isPromo: boolean = false,
		isAddedToBasket: boolean = false
	) {
		if (item?.tags && item.tags.length > 0 && item.tags.find(it => it.identifier === 'custom_bowl')) {
			isAddedToBasket = false;
		}
		if (!isAddedToBasket) {
			this.openModal(item, category, addRecomendations, isPromo);
			return;
		}
		const articleGroup = new ArticleGroup();
		articleGroup.article = item;
		articleGroup.groups.push(...defaultsToArticleOption(item, [], item.defaults, this.order?.type, this.order.preorder.type));
		articleGroup.quantity = 1;
		articleGroup.categoryName = category?.name;
		if (isPromo) {
			articleGroup.isPromo = isPromo;
		}
		const foundGroupToCustomize = (articleGroup.article.groups ?? []).find(group =>
			group.tags.find(ident => ident.identifier === 'select_size')
		);
		if (foundGroupToCustomize) {
			const openSelectSize = await ChooseSizeOfProductComponent.show(this.modalCtrl, articleGroup, foundGroupToCustomize, this.order);
			if (openSelectSize && openSelectSize?.value && (openSelectSize?.value ?? []).length > 0) {
				articleGroup.groups = openSelectSize?.value;
				OrderUtils.addToOrder(this.order, articleGroup, this.analytics);
				this.repository.onOrderChange(this.order);
				// this.showNotification(
				// 	this.translate.instant('add_to_basket.start') +
				// 		articleGroup.article.name.de +
				// 		this.translate.instant('add_to_basket.end')
				// );

				if (openSelectSize.isCheckout) {
					this.toggleBasket();
				}
			}
		} else {
			if (ValidationUtils.areGroupsValid(articleGroup, [])) {
				OrderUtils.addToOrder(this.order, articleGroup, this.analytics);
				this.repository.onOrderChange(this.order);
				// this.showNotification(
				// 	this.translate.instant('add_to_basket.start') +
				// 		articleGroup.article.name.de +
				// 		this.translate.instant('add_to_basket.end')
				// );
			} else {
				this.openModal(item, category, addRecomendations, isPromo);
			}
		}
	}
	async navigateCheckout() {
		// if (AppComponent.largeScreen) {
		// 	this.openCheckout$.next(true);
		// 	setTimeout(() => {
		// 		this.openCheckout$.next(false);
		// 	}, 1000);
		// } else {
		// 	this.navigationService.order();
		// }
	}
	async openModal(
		item: Article,
		category: ArticleCategory,
		addRecomendations: boolean = false,
		isPromo: boolean = false,
		isLoyaltyProduct: boolean = false
	) {
		if (this.showFilters) {
			this.showFilters = false;
		}
		if (this.loading) {
			return;
		}

		const articleGroup = new ArticleGroup();
		articleGroup.article = item;
		articleGroup.groups.push(...defaultsToArticleOption(item, [], item.defaults, this.order?.type, this.order.preorder.type));
		articleGroup.quantity = 1;
		articleGroup.categoryName = category?.name;
		if (isPromo) {
			articleGroup.isPromo = isPromo;
		}
		articleGroup.redeemWithPiggyPoints = isLoyaltyProduct;

		if (isLoyaltyProduct) {
			this.repository.addLoyaltyProduct$.next(false);
			articleGroup.redeemQuantityWithPiggy = 1;
			articleGroup.redeemPointsWithPiggy = item?.piggyReward?.required_credits;
		}
		const modal = await this.modalCtrl.create({
			cssClass: AppComponent.largeScreen ? 'item-modal large-modal' : 'item-modal',
			component: ModalInfoComponent,
			componentProps: {
				articleGroup,
			},
			mode: 'ios',
			backdropDismiss: true,
		});
		await modal.present();
		const response = await modal.onDidDismiss();

		if (response.data && response.data.articleGroup) {
			OrderUtils.addToOrder(this.order, response.data.articleGroup, this.analytics, isLoyaltyProduct);
			this.repository.onOrderChange(this.order);
			this.showNotification(
				this.translate.instant('add_to_basket.start') + articleGroup.article.name.de + this.translate.instant('add_to_basket.end')
			);

			if (response?.data?.isAddToCheckout) {
				this.toggleBasket();
				return;
			}
		}
		if (response.data && response.data.articleGroup && addRecomendations) {
			const mainRecommendations = item.mainRecommendations;

			if (mainRecommendations.length > 0) {
				let categoryArticles = [].concat(...this.venue.articleCategories.map(it => it.articles)) as Article[];
				categoryArticles = categoryArticles.filter(article => article.visible && article.isActive);

				const categoryArticlesMap = new Map(categoryArticles.map(it => [it._id, it]));
				const recommendedArticles: Article[] = [];

				mainRecommendations.forEach(it => {
					if (categoryArticlesMap.has(it)) {
						recommendedArticles.push(categoryArticlesMap.get(it));
					}
				});
				let result;
				if (recommendedArticles.some(art => art.visible)) {
					result = await RecomendationArticleModalComponent.show(this.modalCtrl, recommendedArticles, this.order);
					if (result?.data && result?.data?.length > 0) {
						result.data.forEach(itemRecom => {
							const articleGroup = new ArticleGroup();
							articleGroup.article = itemRecom.article;
							articleGroup.groups.push(
								...defaultsToArticleOption(
									itemRecom.article,
									[],
									itemRecom.article.defaults,
									this.order?.type,
									this.order.preorder.type
								)
							);
							articleGroup.quantity = itemRecom.quantity;
							OrderUtils.addToOrder(this.order, articleGroup, this.analytics);
							this.repository.onOrderChange(this.order);
						});
					}
				}
			}
		}
	}
	onCustomer(): void {}
	onSearchTermChanged(event) {
		this.searchTerm = event;

		this.reloadCategories();
	}

	reloadCategories() {
		if (!this.venue) {
			this.categories = [];
			return;
		}

		// Reload drink subcategories to update available options based on current filters
		this.loadDrinkSubCategories();

		const lowerSearchTerm = this.searchTerm && this.searchTerm !== '' ? this.searchTerm.toLocaleLowerCase() : null;
		this.categories = this.venue.articleCategories
			.filter(category => !category.hidden)
			.map(category => {
				const cat: ArticleCategory = JSON.parse(JSON.stringify(category));
				cat.articles = cat.articles.filter(article => {
					const available = getCustomAvailability(article, OrderType.PREORDER, this.preorderType, null, true, false, true);
					const availableByHours = isAvailableByHours(article);
					let searchItem = true;
					let searchOptionItem = false;
					if (lowerSearchTerm) {
						const keys = [
							article.name.de.toLocaleLowerCase(),
							article.name.en.toLocaleLowerCase(),
							cat.name.de.toLocaleLowerCase(),
							cat.name.en.toLocaleLowerCase(),
						];
						searchItem = keys.map(key => key.indexOf(lowerSearchTerm)).find(result => result >= 0) !== undefined;
					}
					article.groups.forEach(group => {
						group.articles.forEach(artGroup => {
							if (artGroup.visible) {
								if (!searchOptionItem) {
									const keys = [artGroup.name.de.toLocaleLowerCase(), artGroup.name.en.toLocaleLowerCase()];
									searchOptionItem =
										keys.map(key => key.indexOf(lowerSearchTerm)).find(result => result >= 0) !== undefined;
								}
							}
						});
					});

					if (article.name.de.includes('Black Rice Lachs Avocado Bowl')) {
						console.log(article);
					}
					return available && (searchItem || searchOptionItem) && availableByHours;
				});
				if (this.selectedToggleTag !== TOGGLE_TAG.All) {
					cat.articles = cat.articles.filter(article => {
						if (this.selectedToggleTag === TOGGLE_TAG.Vegeterian) {
							return article.compound?.features?.vegetarian;
						} else if (this.selectedToggleTag === TOGGLE_TAG.Vegan) {
							return article.compound?.features?.vegan;
						} else if (this.selectedToggleTag === TOGGLE_TAG.Meat) {
							return (
								article.compound?.features?.beef || article.compound?.features?.chicken || article.compound?.features?.pork
							);
						} else if (this.selectedToggleTag === TOGGLE_TAG.Fish) {
							return article.compound?.features?.fish;
						} else if (this.selectedToggleTag === TOGGLE_TAG.Alcohol) {
							return !article.compound?.additives?.containsAlcohol;
						} else {
							return false;
						}
					});
				}

				if (this.selectedFiltersArray?.length > 0) {
					cat.articles = cat.articles.filter(article => {
						let articleFilter = false;
						this.selectedFiltersArray.forEach(it => {
							if (it === 'vegan') {
								if (
									article?.compound?.features &&
									article.compound.features['vegetarian'] &&
									article.compound.features['vegetarian'] == true
								) {
									articleFilter = true;
								}
							}
							if (article?.compound?.features && article.compound.features[it] && article.compound.features[it] == true) {
								articleFilter = true;
							}
						});
						return articleFilter;
					});
				}

				if (this.selectedDrinkSubCategory && cat.mainCategory === ArticleCategoryType.BEVERAGE) {
					cat.articles = cat.articles.filter(article => {
						return article.tags?.some(tag => tag.identifier === this.selectedDrinkSubCategory);
					});
				}

				return cat;
			})
			.filter(category => category.articles.length > 0);
		if (this.categories.length == 0) {
			this.snackbarCtrl.open(this.translate.instant('not_found_articles'), null, {
				duration: 3000,
			});
		}
		return;
	}

	onVenue() {
		super.onVenue();
		if (!this.venue) {
			this.repository
				.getVenue(this.order && this.order.venue)
				.then(venue => {
					this.repository.venue.emit(venue);
				})
				.catch(_ => {
					this.reloadCategories();
					this.selectedCategoryIndex = 0;
				});
			return;
		}
		this.loadDrinkSubCategories();
		this.reloadCategories();
		this.selectedCategoryIndex = 0;
	}

	onVenueError(error) {
		super.onVenueError(error);
		this.snackbarCtrl.open(axiosErrorToMessage(this.translate, error));
		this.loading = false;
		this.snackbarCtrl.open(
			this.translate.instant('menu_page.venue_timed_out'),
			this.translate.instant('menu_page.venue_timed_out_action')
		);
	}

	async scrollArticleListTo(index: number, time: number = 0) {
		if (!this.articleList) {
			return;
		}
		await this.articleList.scrollToPoint(0, this.articleList?.el?.children[index]?.offsetTop + 10, time);
	}
	async goHome() {
		await this.repository.cleanRepository();
		// await this.navigationService.map();
		this.router.navigateByUrl('/map', {
			replaceUrl: true,
		});
	}
	async goMap() {
		await this.repository.cleanRepository();
		// await this.navigationService.map();
		this.router.navigateByUrl('/map', {
			replaceUrl: true,
		});
	}
	changeSearchbar() {
		this.searchBarOpen = !this.searchBarOpen;
	}

	clearInput() {
		this.searchTerm = '';
		this.searchBarOpen = !this.searchBarOpen;
		this.reloadCategories();
	}
	findFlag() {
		return '/assets/' + this.translate.currentLang + '.svg';
	}

	toggleTagValue(value: TOGGLE_TAG) {
		this.selectedToggleTag = value;
		this.reloadCategories();
	}
	showFiltersFunc(value: boolean) {
		this.showFilters = value;
	}
	selectedFiltersCompound(value: string[]) {
		this.compoundFilers = value;
		this.reloadCategories();
	}
	nextSlide() {
		this.slider.nativeElement.swiper.slideNext();
	}
	findCategoryIndex(categories: ArticleCategory[]) {
		return categories.find(it => it?._id === this.selectedCategory?._id) ?? categories[0];
	}
	showNotification(message: string) {
		this.messageNotification = message;
		this.showMessageNotification = true;
		clearTimeout(this.notificationTimeout);

		// Set a new timeout
		this.notificationTimeout = setTimeout(() => {
			this.showMessageNotification = false;
			this.messageNotification = '';
		}, 4000);
	}
	async toggleBasket() {
		// this.isOpenBasket$.next(!this.isOpenBasket$.value);
		await OrderContentModalComponent.presentModal(this.modalCtrl);
	}
	async showPopoverToBack(ev: any) {
		if (this.isOpenPopoverBack) {
			return;
		}
		if (this.order && this.order?.orderedArticles?.length === 0) {
			this.navigationService.map();
			return;
		}
		this.isOpenPopoverBack = true;
		const popover = await this.popover.create({
			component: ChangeVenuePopoverComponent,
			event: ev,
			translucent: true,
			cssClass: 'popover-select-language',
			showBackdrop: false,
			componentProps: {
				lang: this.translate.currentLang,
			},
		});
		popover.onWillDismiss().then(v => {
			if (v?.data == LeaveVenue.NAVIGATE_BACK) {
				// this.back.emit();
				this.navigationService.map();
			}
			this.isOpenPopoverBack = false;
		});
		await popover.present();
	}
	selectedFilters(event: string[]) {
		this.showFilters = false;
		if (event.length > 0) {
			this.selectedFiltersArray = event;
		} else {
			this.selectedFiltersArray = [];
		}
		this.reloadCategories();
	}
	trackBy(index: number, item: Article) {
		return item._id;
	}
	trackByCategory(index: number, item: ArticleCategory) {
		return item._id;
	}
	removeBasket(article: Article) {
		console.log('REMOVE', article);
		const findIndex = this.order.orderedArticles.findIndex(it => it.article._id === article._id);
		console.log('found index', findIndex);
		if (findIndex >= 0) {
			const result = this.order.orderedArticles[findIndex];
			if (result.quantity > 1) {
				this.order.orderedArticles[findIndex].quantity -= 1;
			} else {
				this.order.orderedArticles = this.order.orderedArticles.filter((it, index) => index !== findIndex);
			}
		}
		console.log(this.order);
		this.repository.onOrderChange(this.order);
	}

	async selectLanguageModal() {
		await SelectLanguageModalComponent.show(this.modalCtrl);
	}
	toggleVeganFilter() {
		if (this.selectedFiltersArray.includes('vegan')) {
			this.selectedFiltersArray = this.selectedFiltersArray.filter(it => it !== 'vegan');
		} else {
			this.selectedFiltersArray.push('vegan');
		}
		this.reloadCategories();
	}

	hasVegan() {
		return this.selectedFiltersArray.includes('vegan');
	}

	clearFilters() {
		this.selectedFiltersArray = [];
		this.reloadCategories();
	}

	async openFilters() {
		const result = await FiltersModalComponent.show(this.modalCtrl, this.selectedFiltersArray);
		this.selectedFiltersArray = result;
		this.reloadCategories();
	}

	toggleDrinkSubCategory(identifier: string) {
		if (this.selectedDrinkSubCategory === identifier) {
			this.selectedDrinkSubCategory = null; // Deselect if clicking the same category
		} else {
			this.selectedDrinkSubCategory = identifier; // Select new category
		}

		// Only update beverage categories without full reload
		this.updateBeverageCategories();
	}

	private loadDrinkSubCategories() {
		if (!this.venue) return;

		const foundTags = new Map();
		const tagArticleCounts = new Map();

		// Search through all beverage categories to find all tags that start with "filter_"
		// and count articles for each tag
		this.venue.articleCategories.forEach(category => {
			if (category.mainCategory === ArticleCategoryType.BEVERAGE) {
				category.articles.forEach(article => {
					article.tags?.forEach(tag => {
						if (tag.identifier.startsWith('filter_')) {
							// Store tag info if not already stored
							if (!foundTags.has(tag.identifier)) {
								foundTags.set(tag.identifier, {
									identifier: tag.identifier,
									name: tag.name,
								});
								tagArticleCounts.set(tag.identifier, 0);
							}
							// Count articles for this tag (considering availability and current filters)
							const available = getCustomAvailability(
								article,
								OrderType.PREORDER,
								this.preorderType,
								null,
								true,
								false,
								true
							);
							const lowerSearchTerm = this.searchTerm && this.searchTerm !== '' ? this.searchTerm.toLocaleLowerCase() : null;
							let searchItem = true;

							if (lowerSearchTerm) {
								const keys = [
									article.name.de.toLocaleLowerCase(),
									article.name.en.toLocaleLowerCase(),
									category.name.de.toLocaleLowerCase(),
									category.name.en.toLocaleLowerCase(),
								];
								searchItem = keys.map(key => key.indexOf(lowerSearchTerm)).find(result => result >= 0) !== undefined;
							}

							if (available && searchItem) {
								tagArticleCounts.set(tag.identifier, tagArticleCounts.get(tag.identifier) + 1);
							}
						}
					});
				});
			}
		});

		// Convert to array sorted alphabetically by identifier, but only include tags that have articles
		this.drinkSubCategories = Array.from(foundTags.values())
			.filter(tag => tagArticleCounts.get(tag.identifier) > 0)
			.sort((a, b) => a.identifier.localeCompare(b.identifier));
	}

	private updateBeverageCategories() {
		if (!this.venue) return;

		// Find and update only beverage categories
		this.categories.forEach(cat => {
			if (cat.mainCategory === ArticleCategoryType.BEVERAGE) {
				// Get original articles from venue
				const originalCategory = this.venue.articleCategories.find(original => original._id === cat._id);
				if (originalCategory) {
					// Apply the same filtering logic as reloadCategories but only for this category
					let filteredArticles = originalCategory.articles.filter(article => {
						const available = getCustomAvailability(article, OrderType.PREORDER, this.preorderType, null, true, false, true);
						let searchItem = true;
						let searchOptionItem = false;
						const lowerSearchTerm = this.searchTerm && this.searchTerm !== '' ? this.searchTerm.toLocaleLowerCase() : null;

						if (lowerSearchTerm) {
							const keys = [
								article.name.de.toLocaleLowerCase(),
								article.name.en.toLocaleLowerCase(),
								cat.name.de.toLocaleLowerCase(),
								cat.name.en.toLocaleLowerCase(),
							];
							searchItem = keys.map(key => key.indexOf(lowerSearchTerm)).find(result => result >= 0) !== undefined;
						}

						article.groups.forEach(group => {
							group.articles.forEach(artGroup => {
								if (artGroup.visible) {
									if (!searchOptionItem) {
										const keys = [artGroup.name.de.toLocaleLowerCase(), artGroup.name.en.toLocaleLowerCase()];
										searchOptionItem =
											keys.map(key => key.indexOf(lowerSearchTerm)).find(result => result >= 0) !== undefined;
									}
								}
							});
						});

						return available && (searchItem || searchOptionItem);
					});

					// Apply drink sub-category filtering
					if (this.selectedDrinkSubCategory) {
						filteredArticles = filteredArticles.filter(article => {
							return article.tags?.some(tag => tag.identifier === this.selectedDrinkSubCategory);
						});
					}

					// Update the category's articles
					cat.articles = filteredArticles;
				}
			}
		});
	}
}
